import $ from 'jquery';

$(document).on('click', '.reciteme', function() {
  loadService();
  console.log('Reciteme loading...');
  return false;
});
